import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2';
import * as React from 'react';
import type { InputComponentProps } from '../../design-system';
import { getNestedHelperText, toChangeEvent } from '../../utils/formUtils';
import { TextField } from '../TextField';

export type WizardOcppChargePointId = {
  prefix: string;
  suffix: string;
};

export const OCPP_CHARGE_POINT_ID_MAX_LENGTH = 48;
export const PREFIX_NAME_MAX_LENGTH = 6;

export const PrefixText: React.FC<InputComponentProps<WizardOcppChargePointId, string>> = ({
  name,
  disabled,
  error,
  helperText,
  value: { prefix, suffix },
  onBlur,
  onChange,
}) => (
  <Grid container>
    <Grid xs={3}>
      <Tooltip
        arrow
        placement="top"
        title="This is a prefix for your OCPP Charge Point ID. It is automatically generated for your organisation."
      >
        <span>
          <TextField
            InputProps={{ readOnly: true }}
            defaultValue={`${prefix}-`}
            disabled
            helperText="Prefix"
            id="prefix"
            sx={{ marginTop: 0, marginRight: '0.5em' }}
          />
        </span>
      </Tooltip>
    </Grid>
    <Grid xs={9}>
      <TextField
        disabled={disabled}
        error={error}
        fullWidth
        helperText={getNestedHelperText(helperText)}
        id="suffix"
        inputElementProps={{
          'aria-label': `ocpp-id-input`,
          maxLength: OCPP_CHARGE_POINT_ID_MAX_LENGTH - PREFIX_NAME_MAX_LENGTH,
        }}
        onBlur={onBlur}
        onChange={({ target }) => {
          const newId = { prefix, suffix: target.value.toUpperCase() };
          onChange(name)(toChangeEvent<WizardOcppChargePointId>(new Event('change'), newId));
        }}
        value={suffix}
      />
    </Grid>
    <Typography
      style={{
        fontSize: '0.75rem',
        paddingLeft: '14px',
        paddingTop: '8px',
        color: 'rgba(0, 0, 0, 0.54)',
      }}
    >
      Your OCPP charge point ID is: {`${prefix}-${suffix}`}
    </Typography>
  </Grid>
);
